<ng-template #noDivs>
	<p *ngIf="!loading">0 divisions</p>
</ng-template>

<div id="division-filter-v2" (keydown.escape)="panel.close()" [ngClass]="{
		'missing-division': isMissingDivision
	}">
	<mat-expansion-panel #panel [disabled]="defaultDivisions.length <= 1" [cdkTrapFocus]="panel.expanded"
		[cdkTrapFocusAutoCapture]="panel.expanded" (opened)="onPanelOpened()" (closed)="onPanelClosed()">
		<mat-expansion-panel-header>
			<mat-panel-title>
				{{ title }}
			</mat-panel-title>
		</mat-expansion-panel-header>
		<app-search-input placeholder="Search for division" (inputChanged)="inputChanged($event)"></app-search-input>

		<ngx-skeleton-loader count="3" *ngIf="loading"></ngx-skeleton-loader>

		<div
			tabindex="0"
			role="listbox"
			style="outline: none;"
			class="checkboxes"
			*ngIf="!loading"
			#checkboxesContainer
			(focus)="focusFirstOption(checkboxesContainer)"
			(keydown)="onDivisionKeydown($event, checkboxesContainer)"
		>
			<ng-container *ngIf="divisions?.length; else noDivs">
				<mat-checkbox
					tabindex="-1"
					*ngFor="let div of divisions"
					[checked]="div.divisionId === selectedDivision?.divisionId"
					(change)="change(div, $event.checked)"
				>
					{{ div.divisionName }}
				</mat-checkbox>
			</ng-container>
		</div>
		<div class="button-container">
			<app-action-button title="Cancel" (buttonClicked)="cancelClicked()"></app-action-button>
			<app-action-button title="Apply" [disabled]="divisions.length === 0 || !_boolean(selectedDivision)"
				(buttonClicked)="applyClicked()"></app-action-button>
		</div>
	</mat-expansion-panel>
	<div class="division-required" *ngIf="isMissingDivision">
		Select a division before proceeding.
	</div>
</div>
